(() => {
  const normalize = (value) => String(value || '').trim().toLowerCase();
  let lakeIndexPromise;

  const getLakeIndex = async (section) => {
    if (!lakeIndexPromise) {
      const assetUrl = section?.dataset?.lakeIndex || window.Shopify?.routes?.root + 'cdn/shop/t/0/assets/lb-lake-index.json';
      lakeIndexPromise = fetch(assetUrl).then((response) => response.json()).catch(() => ({ lakes: [] }));
    }

    return lakeIndexPromise;
  };

  const renderResults = (container, lakes) => {
    if (!container) return;

    if (!lakes.length) {
      container.innerHTML = '<p>No matching lakes yet. Request yours and we will prioritize it.</p>';
      return;
    }

    container.innerHTML = lakes.slice(0, 8).map((lake) => {
      const status = String(lake.status || '').replaceAll('_', ' ');
      return `
        <a class="lb-lake-result" href="${lake.cta || '/pages/request-a-lake'}">
          <strong>${lake.name}, ${lake.state}</strong>
          <span>${lake.region || lake.collection || ''} · ${status}</span>
        </a>
      `;
    }).join('');
  };

  const updateSearch = async (input) => {
    const section = input.closest('[data-lb-lake-search-section]') || document.querySelector('[data-lb-lake-search-section]');
    const container = input.parentElement?.querySelector('[data-lb-lake-results]') || section?.querySelector('[data-lb-lake-results]');
    const data = await getLakeIndex(section);
    const query = normalize(input.value);
    const activeRegion = section?.querySelector('[data-lb-region][aria-pressed="true"]')?.dataset.lbRegion || 'all';

    const matches = (data.lakes || []).filter((lake) => {
      const haystack = normalize([lake.name, lake.state, lake.region, lake.collection].join(' '));
      const regionMatch = activeRegion === 'all' || lake.region === activeRegion;
      return regionMatch && (!query || haystack.includes(query));
    });

    renderResults(container, matches);
  };

  const initLakeSearch = () => {
    document.querySelectorAll('[data-lb-lake-search]').forEach((input) => {
      input.addEventListener('input', () => updateSearch(input));
      updateSearch(input);
    });

    document.querySelectorAll('[data-lb-region]').forEach((button) => {
      button.addEventListener('click', () => {
        const section = button.closest('[data-lb-lake-search-section]');
        section?.querySelectorAll('[data-lb-region]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', 'true');
        const input = section?.querySelector('[data-lb-lake-search]');
        if (input) updateSearch(input);
      });
    });
  };

  const initLakeDirectory = () => {
    document.querySelectorAll('[data-lb-lake-directory]').forEach((directory) => {
      const input = directory.querySelector('[data-lb-directory-search]');
      const filters = [...directory.querySelectorAll('[data-lb-directory-filter]')];
      const cards = [...directory.querySelectorAll('[data-lb-directory-card]')];
      const groups = [...directory.querySelectorAll('[data-lb-directory-group]')];
      const empty = directory.querySelector('[data-lb-directory-empty]');
      let activeState = 'all';

      const update = () => {
        const query = normalize(input?.value);
        let visibleCount = 0;

        cards.forEach((card) => {
          const haystack = normalize([card.dataset.lakeName, card.dataset.lakeState, card.dataset.lakeRegion].join(' '));
          const stateMatch = activeState === 'all' || normalize(card.dataset.lakeState) === activeState;
          const matches = stateMatch && (!query || haystack.includes(query));
          card.hidden = !matches;
          if (matches) visibleCount += 1;
        });

        groups.forEach((group) => {
          const hasVisibleCard = [...group.querySelectorAll('[data-lb-directory-card]')].some((card) => !card.hidden);
          group.hidden = !hasVisibleCard;
        });

        if (empty) empty.hidden = visibleCount > 0;
      };

      input?.addEventListener('input', update);
      filters.forEach((filter) => {
        filter.addEventListener('click', () => {
          activeState = normalize(filter.dataset.lbDirectoryFilter) || 'all';
          filters.forEach((item) => item.setAttribute('aria-pressed', String(item === filter)));
          update();
        });
      });

      update();
    });
  };

  const initPersonalizationFields = () => {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    if (!productForm.id) {
      productForm.id = `LakeBlanketsProductForm-${Date.now()}`;
    }

    document.querySelectorAll('[data-lb-line-item-property]').forEach((input) => {
      input.setAttribute('form', productForm.id);
    });
  };

  const initHeaderLiveSearch = () => {
    const search = document.querySelector('.lb-global-actions .header__search');
    const details = search?.querySelector('details');
    const form = search?.querySelector('form[role="search"]');
    const input = search?.querySelector('input[type="search"]');
    if (!details || !form || !input) return;

    details.addEventListener('toggle', () => {
      document.body.classList.toggle('lb-search-open', details.open);
    });

    form.addEventListener('submit', (event) => {
      if (!input.value.trim()) return;
      event.preventDefault();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initLakeSearch();
    initLakeDirectory();
    initPersonalizationFields();
    initHeaderLiveSearch();
  });
})();
